module.exports = __webpack_public_path__ + "static/property6-dfc455721cc1cbc5575e376bef516699.png";